<template>
  <div class="content">
    <div class="title">健康资讯</div>
    <div class="hp_space_between">
      <div>
        <div class="hp_cz_center_s new_tab">
          <div class="left hp_cz_center">
            <div :class="{ active: !tabIndex }" @click="changeTab(0)">
              动态资讯
            </div>
            <div :class="{ active: tabIndex }" @click="changeTab(1)">
              健康宣教
            </div>
          </div>
          <div @click="toPage" class="more" style="font-size:14px">
            查看更多
            <a-icon style="width:24px;color:#686868;" type="double-right" />
          </div>
        </div>
        <template v-if="list && list.length > 0">
          <newsDemo
            :obj="item"
            v-for="(item, index) in list"
            :key="index"
          ></newsDemo>
          <div v-if="false">
            <a-pagination
              show-quick-jumper
              :current="currPage"
              :total="totalCount"
              :defaultPageSize="form.pageSize"
              @change="onChange"
            />
          </div>
        </template>
        <noData v-else></noData>
      </div>
      <div>
        <div
          class="advertising hp_center cursor-point"
          v-for="(item, index) in adverts2"
          :key="index"
        >
          <img
            :src="base_url + item.images"
            @click="goUrlLink(item.sourceUrl)"
            alt
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import newsDemo from './newsDemo'
import { getArticle, getAdverts } from '@/api/index'
import noData from '@/components/NoData'
// import {ls} from '@/utils/tool';
export default {
  components: {
    newsDemo,
    noData,
  },
  data() {
    return {
      tabIndex: 0,
      form: {
        pageNum: 1,
        pageSize: 6,
        columnType: 1,
      },
      list: [],
      currPage: 1,
      totalCount: 1,
      advertForm: {
        pageNum: 1,
        pageSize: 3,
      },
      adverts2: [], //右边广告
    }
  },
  mounted() {
    this.init()
    this.initAdverts2()
  },
  methods: {
    toPage() {
      this.$router.push('/news-bulletin')
    },
    async initAdverts2() {
      var res = await getAdverts({ ...this.advertForm, position: 2 })
      if(res.code==200){
         this.adverts2 = res.data.list 
         return
      }
     this.adverts2 = []
    },
    changeTab(index) {
      this.tabIndex = index
      this.currPage = 1
      this.form.pageNum = 1
      this.form.columnType = index + 1
      this.init()
    },
    async init() {
      var res = await getArticle(this.form)
      this.list = res.data.list || []
      this.totalCount = res.data.totalCount
      this.currPage = res.data.currPage
      console.log('res.data===', res.data)
    },
    onChange(pageNumber) {
      console.log('Page: ', pageNumber)
      this.form.pageNum = pageNumber
      this.init()
    },
    goUrlLink(url) {
      if(url){
          window.location.href = url
          return
      }
      this.$message.warning('无跳转网址')
       
    },
  },
}
</script>
<style scoped lang="less">
.content {
  width: 1200px;
  margin: 0 auto;
  .title {
    font-size: 28px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    line-height: 1;
    margin: 50px auto 33px auto;
    text-align: center;
  }
  .new_tab {
    margin-bottom: 21px;
    .left {
      div {
        width: 142px;
        height: 39px;
        text-align: center;
        font-size: 20px;
        color: #686868;
        line-height: 39px;
        margin-right: 47px;
        cursor: pointer;
      }
    }
    .more {
      cursor: pointer;
      color: #686868;
      font-size: 12px;
    }
    .active {
      // padding: 11px 34px 9px 34px;
      background: #0079fe;
      border-radius: 36px;
      color: #fff !important;
      position: relative;
    }
    .active:before {
      content: '';
      width: 0px;
      height: 0px;
      border-top: 10px solid #0079fe;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      position: absolute;
      top: 39px;
      left: 60px;
    }
  }
  .advertising {
    text-align: right;
    width: 259px;
    height: 289px;
    margin-bottom: 20px;
    overflow: hidden;
    img {
      height: 289px;
    }
  }
}
</style>
